import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

import Section from "components/Section";
import Button from "components/Buttons";
import Row from "components/Row";
import mainSelectors from "modules/main/selectors";
import mainAction from "modules/main/actions";
import facebookSelectors from "modules/facebook/selectors";
const { REACT_APP_FACEBOOK_RP_BUSINESS_ID } = process.env;


const NoConnectedAds = () => {
  const [t] = useTranslation();
  let history = useHistory();
  const dispatch = useDispatch();

  const currentDashboard = useSelector((state) => mainSelectors.currentDashboardResult(state));
  const getFacebookPixelAgenciesResult = useSelector((state) => facebookSelectors.getFacebookPixelAgenciesResult(state));
  const getFacebookSettingsResult = useSelector((state) => facebookSelectors.getFacebookSettingsResult(state));
  
  const goToSetting = (history, currentDashboard) => {
    dispatch(mainAction.currentDashboard("settings"));
    if (currentDashboard.data.dashboard === "google") {
      history.push("/setting");
    } else if (currentDashboard.data.dashboard === "facebook") {
      history.push("/setting/fb");
    } else {
      history.push("/setting");
    }
  };

  const shouldShowFacebookSettingError = () => {
    const setupCompleted =
      getFacebookSettingsResult.data[0]?.setup_status === "completed";
    const hasPixelAgencies = getFacebookPixelAgenciesResult.result !== 0;
    const isRpBusinessId =
      getFacebookSettingsResult.data[0]?.fb_ads_business_id ===
      REACT_APP_FACEBOOK_RP_BUSINESS_ID;
    const isNotNoRpAgency =
      getFacebookPixelAgenciesResult.message !== "NO_RP_AGENCY";

    return (
      (setupCompleted && hasPixelAgencies) ||
      (setupCompleted && isRpBusinessId && hasPixelAgencies && isNotNoRpAgency)
    );
  };

  return (
    <StyledSectionBox>
      <StyledSection>
        <CenteredDiv>
          {shouldShowFacebookSettingError()
            ? t("__ads_facebook_setting_error")
            : t("__noads_description")}
        </CenteredDiv>
        <Row className="button-container">
          <Button round onClick={() => goToSetting(history, currentDashboard)}>
            {t("__noads_setting_button")}
          </Button>
        </Row>
      </StyledSection>
    </StyledSectionBox>
  );
};

export default NoConnectedAds;

const StyledSectionBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledSection = styled(Section)`
  max-width: 600px;
  width: 100%;
  margin: auto;
`;

const CenteredDiv = styled.div`
  text-align: center;
`;
